export interface NavigationModel {
    navPath: string;
    iconActivePath: string;
    iconInActivePath: string;
    menuName: string;
    navMenuId?: string;
}

export enum ProductType {
    SWIFT='Swift',
    NCASH='nCash'
}

export interface QuickSetupModel {
    productTypeName: ProductType;
    productTypeDescription: string;
    toolTip: string;
    productChecked: boolean;
}